export default __webpack_public_path__ + "static/DigitalTransformation-Web-e2482afeae6600db14ba592218847208.png";